import service from './index'

const prefix = "/freyr-tm";

export const fetchSubscriptionModuleList = (tenantId: string) => service.get(`${prefix}/tmSubscription/getByTenantId/${tenantId}`);

export const fetchModuleById = (moduleId: number) => service.get(`${prefix}/tmModule/${moduleId}`);

export const fetchDomainList = () => service.get(`${prefix}/tmDomain/list`);

export const tenantInfo = (tenantId: string) => service.get(`${prefix}/tmTenant/${tenantId}`);